import Box from '@material-ui/core/Box';
import React from 'react';
import ForecastCashGraph from '../../cash/ForecastCashGraph';
import ReportCashTable from './ReportCashTable';
const ReportCash = ({ forecast }) => {
    return (React.createElement(Box, { width: "100%" },
        React.createElement(Box, { className: "forecast-report__graph", width: "100%", minHeight: 480 },
            React.createElement(ForecastCashGraph, { forecast: forecast.values, noAnimate: true })),
        React.createElement(Box, { width: "100%", style: {
                pageBreakInside: 'avoid',
            } },
            React.createElement(ReportCashTable, { forecast: forecast.values }))));
};
export default ReportCash;
